/**
 * Chat Service - Wrapper for chatWithDiary Cloud Function
 * Provides interface to Best Friend AI with RAG retrieval
 */

import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

const chatCallable = httpsCallable(functions, 'chatWithDiary');

/**
 * Send a message to the Best Friend AI and get a response based on diary history
 * @param {string} message - The user's message/question
 * @returns {Promise<{reply: string, usedMemories: import('../types/entry').UsedMemory[]}>}
 * @throws {Error} If the request fails
 */
export const sendChatMessage = async (message, assistantName) => {
  if (!message || typeof message !== 'string' || !message.trim()) {
    throw new Error('Message is required and must be a non-empty string');
  }

  try {
    const trimmedAssistantName = typeof assistantName === 'string' ? assistantName.trim() : '';
    const result = await chatCallable({
      message: message.trim(),
      assistantName: trimmedAssistantName || undefined
    });
    return result.data;
  } catch (error) {
    console.error('Error sending chat message:', error);
    
    // Provide user-friendly error messages
    if (error.code === 'unauthenticated') {
      throw new Error('Please sign in to chat');
    } else if (error.code === 'permission-denied') {
      throw new Error('You do not have permission to access this feature');
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error('Failed to send message. Please try again.');
    }
  }
};
